// Synoptis Pharma
export const SYNOPTIS_STRAINS = [
  {
    id: "synoptis-cataract-kush-18",
    name: "Cataract Kush",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "LA Confidential × OG Kush",
    thc: 18, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Drzewny", "Owocowy", "Pikantny", "Słodki", "Ziemisty", "Ziołowy"],
    description: "Cataract Kush to indica o klasycznym, kushowym charakterze, powstała z połączenia LA Confidential i OG Kush. Dominujący mircen odpowiada za głęboki relaks mięśniowy i działanie sedatywne, wspierając sen i redukując napięcie. Kariofilen — wiążąc się bezpośrednio z receptorami CB2 — zapewnia silne działanie przeciwzapalne i przeciwbólowe. Linalol wzmacnia efekt uspokajający i przeciwlękowy, a limonen może wywoływać początkową euforię i poprawę nastroju.",
    terpenes: { mircen: 28, kariofilen: 20, limonen: 17, linalol: 9, humulen: 6, pinen: 14 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "synoptis-triangle-mints",
    name: "Triangle Mints",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Triangle Kush × Animal Mints",
    thc: 25, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Korzenny", "Ziemisty", "Ziołowy"],
    description: "Triangle Mints to hybryda/sativa (70:30) od Synoptis Pharma z THC 25%. Dominujący kariofilen zapewnia silne działanie przeciwzapalne i przeciwbólowe poprzez bezpośrednią aktywację receptorów CB2. Limonen wspiera poprawę nastroju i działa energetyzująco, a mircen łagodzi napięcie i uzupełnia profil relaksacyjnym tłem. Odmiana odpowiednia do stosowania w ciągu dnia.",
    terpenes: { kariofilen: 40, limonen: 30, mircen: 20 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "synoptis-powdered-donuts",
    name: "Powdered Donuts",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Jet Fuel Gelato × Orange Cookies",
    thc: 25, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Cytrusowy", "Słodki", "Ziemisty"],
    description: "Powdered Donuts to hybryda/indica (60:40) od Synoptis Pharma z THC 25%. Dominujący kariofilen zapewnia silne działanie przeciwzapalne i przeciwbólowe poprzez bezpośrednią aktywację receptorów CB2. Mircen pogłębia fizyczne odprężenie i relaksację mięśniową, a limonen i linalol wspierają poprawę nastroju oraz działają uspokajająco i przeciwlękowo. Odmiana przeznaczona do stosowania w godzinach popołudniowych i wieczornych.",
    terpenes: { kariofilen: 31, mircen: 19, limonen: 11, linalol: 11, pinen: 8 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "synoptis-lilac-diesel",
    name: "Lilac Diesel",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodówód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Odmiana dodająca energii i aktywizująca, dzięki dominującemu terpinolenowi i limonenowi. Mircen powoduje, że susz zmniejsza napięcie mięśniowe i powoduje efekt rozluźnienia.",
    terpenes: { terpinolen: 23, mircen: 8, pinen: 7, kariofilen: 8, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "synoptis-lilac-diesel-18",
    name: "Lilac Diesel",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "nieznany rodówód",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Diesel", "Kwiatowy", "Lawendowy"],
    description: "Odmiana dodająca energii i aktywizująca, dzięki dominującemu terpinolenowi i limonenowi. Mircen powoduje, że susz zmniejsza napięcie mięśniowe i powoduje efekt rozluźnienia.",
    terpenes: { terpinolen: 23, mircen: 8, pinen: 7, kariofilen: 8, limonen: 6, bisabolol: 3, humulen: 3 },
    dominantTerpene: "Terpinolen", packaging: "15g"
  },
  {
    id: "synoptis-galaxy-walker-og",
    name: "Galaxy Walker OG",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Korzenny", "Miętowy", "Pieprzowy", "Sosnowy"],
    description: "Indica od firmy Synoptis Pharma z niezwykle bogatym profilem terpenowym. Wyraźna obecność nerolidolu oraz kariofilenu przekłada się na silne właściwości przeciwbólowe, przeciwzapalne i antyspastyczne. Limonen i linalol wspierają poprawę nastroju. Zrównoważone połączenie fizycznego odprężenia i jasności umysłu.",
    terpenes: { nerolidol: 30, linalol: 7, mircen: 6, pinen: 4, humulen: 7, kariofilen: 26, limonen: 8, bisabolol: 12 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "synoptis-pink-kush",
    name: "Pink Kush",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "OG Kush × Hindu Kush",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kamfora", "Pieprzowy", "Pikantny", "Kwiatowy"],
    description: "Indica od firmy Synoptis Pharma, powstała z połączenia renomowanych odmian OG Kush i Hindu Kush. Znana ze skutecznego działania przeciwbólowego i przeciwlękowego, dzięki bisabololowi i nerolidolowi. Działa korzystnie w przypadku zaburzeń snu i bezsenności. Pacjenci zgłaszają początkowe lekkie pobudzenie i późniejszy spokój oraz poprawę jakości snu.",
    terpenes: { nerolidol: 6, kariofilen: 5, bisabolol: 2, humulen: 1 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "synoptis-pink-kush-18",
    name: "Pink Kush",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "OG Kush × Hindu Kush",
    thc: 18, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Kamfora", "Pieprzowy", "Pikantny", "Kwiatowy"],
    description: "Indica od firmy Synoptis Pharma, powstała z połączenia renomowanych odmian OG Kush i Hindu Kush. Znana ze skutecznego działania przeciwbólowego i przeciwlękowego, dzięki bisabololowi i nerolidolowi. Działa korzystnie w przypadku zaburzeń snu i bezsenności.",
    terpenes: { nerolidol: 6, kariofilen: 5, bisabolol: 2, humulen: 1 },
    dominantTerpene: "Nerolidol", packaging: "15g"
  },
  {
    id: "synoptis-facade",
    name: "Facade",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Eye Candy × Apples & Bananas",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Owocowy", "Pieprzowy", "Sosnowy", "Ziołowy"],
    description: "Hybryda z lekką przewagą indici od firmy Synoptis Pharma. Początkowo zapewnia jasność i klarowność umysłu, następnie powodując uspokojenie i relaks, co zawdzięczamy mircenowi i linalolowi. Pacjenci zgłaszają pobudzenie i zwiększenie energii od razu po zażyciu odmiany.",
    terpenes: { limonen: 21, kariofilen: 20, mircen: 11, linalol: 10, humulen: 8, pinen: 8, terpinolen: 5, farnezen: 5, bisabolol: 3 },
    dominantTerpene: "Limonen", packaging: "15g"
  },
  {
    id: "synoptis-master-kush",
    name: "Master Kush",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Indica",
    lineage: "Hindu Kush × Skunk",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Relaksujące",
    aromas: ["Kamfora", "Korzenny", "Pieprzowy", "Ziemisty"],
    description: "Indica o znacząco dominującym mircenie w profilu terpenowym, co działa uspokajająco i relaksująco. Susz redukuje stres i napięcie, wykazując dodatkowo działanie antyspastyczne i nasenne.",
    terpenes: { mircen: 43, pinen: 4, kariofilen: 9, limonen: 6, linalol: 2 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "synoptis-purps",
    name: "Purps",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Korzenny", "Pieprzowy", "Ziemisty"],
    description: "Hybrydowa odmiana od Synoptis Pharma z przewagą genów indica (ok. 70%), wyróżniająca się głębokim, uspokajającym działaniem i intensywnym aromatem. Właściwości relaksacyjne i poprawiające jakość snu susz zawdzięcza obecności nerolidolu, mircenu i linalolu.",
    terpenes: { nerolidol: 24, kariofilen: 25, limonen: 11, bisabolol: 11, linalol: 8, mircen: 6, pinen: 5, humulen: 9, ocymen: 1 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "synoptis-frosted-cherry-cookies-22",
    name: "Frosted Cherry Cookies",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Cytrusowy", "Jagodowy", "Ziołowy"],
    description: "Hybryda/indica o proporcjach 70:30. Mircen odpowiada za działanie relaksujące i rozluźniające mięśnie, a limonen za początkową aktywizacją i poprawę nastroju.",
    terpenes: { mircen: 27, pinen: 27, kariofilen: 11, humulen: 6, limonen: 8 },
    dominantTerpene: "Mircen", packaging: "15g"
  },
  {
    id: "synoptis-wappa-22",
    name: "Wappa",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Drzewny", "Owocowy", "Słodki"],
    description: "Dominujący kariofilen odpowiada za działanie przeciwzapalne i przeciwbólowe, co potęguje mircen, któremu odmiana zawdzięcza właściwości poprawiające jakość snu. Efekt uspokajający wzmaga obecny w suszu linalol.",
    terpenes: { kariofilen: 34, mircen: 20, pinen: 16, humulen: 10, linalol: 5 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  },
  {
    id: "synoptis-wappa-25",
    name: "Wappa",
    producer: "Synoptis Pharma",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "nieznany rodowód",
    thc: 25, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Drzewny", "Owocowy", "Słodki"],
    description: "Dominujący kariofilen odpowiada za działanie przeciwzapalne i przeciwbólowe, co potęguje mircen, któremu odmiana zawdzięcza właściwości poprawiające jakość snu. Efekt uspokajający wzmaga obecny w suszu linalol.",
    terpenes: { kariofilen: 34, mircen: 20, pinen: 16, humulen: 10, linalol: 5 },
    dominantTerpene: "Kariofilen", packaging: "15g"
  }
];